module.exports = __webpack_public_path__ + "static/media/frontend.1fba5686.png";